import { Component,  OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { FormGroup, FormControl, Validators} from "@angular/forms";
import { SiteService } from "src/app/_services/site.service";
import { ErrorUtil } from "src/app/_utilities/error";

@Component({
  selector: "app-create-block-area-lvl",
  standalone: false,
  templateUrl: "./create-block-area-lvl.component.html",
  styleUrl: "./create-block-area-lvl.component.scss",
})
export class CreateBlockAreaLvlComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  siteBlockForm!: FormGroup;
  data: any;
  layerCreationInProgress: boolean = false;

  constructor(
    public modalRef: BsModalRef,
    private siteServc: SiteService, private modalServc: BsModalService,
    private languageTranslateService: LanguageTranslateService,
    private errorUtil: ErrorUtil) {

    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
    console.log(this.data, 'data printing in block modal')
    this.siteBlockForm = new FormGroup({
      blockName: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z0-9\s]+$/),
        Validators.maxLength(80)
      ]),
    });
  }
  //Language
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  get layerLabel(): string {
    if (this.data?.layer === 'block') return this.translate?.site.sections.sec6.singular;
    if (this.data?.layer === 'level') return this.translate?.site.fields.level.singular;
    if (this.data?.layer === 'area') return this.translate?.site.fields.area.singular;
    return this.data?.layer;
  }

  get layerLabelLower(): string {
    return this.layerLabel?.toLowerCase();
  }
  onLayerCreate() {
    if (this.siteBlockForm.valid) {

      let payload: any = {};

      if (this.data.layer == 'block'){
        payload= {
          name: this.siteBlockForm.get("blockName")?.value,
          site: { id: this.data.siteId },
        };
      }
      else if(this.data.layer == 'level'){
        payload = {
          name: this.siteBlockForm.get("blockName")?.value,
          siteBlock: { id: this.data.layerId }, //block id
        };
      }
      else if (this.data.layer == "area") {
        payload = {
          name: this.siteBlockForm.get("blockName")?.value,
          siteLevel: { id: this.data.layerId }, //level id
        };
      } else {}

      this.layerCreationInProgress = true;

      this.siteServc.createBlock(payload, this.data.layer).subscribe({
        next: (res: any) => {
          if (res.status == 200 || res.status == 201) {
            this.errorUtil.setErrorMessage(
              200,
              this.translate?.general.messages.savedSuccessfully,
              null,
              "success",
              2000,
            );

            let jsonObj: any = {
              layer: this.data.layer,
              reason: "newdata_added",
            };
            this.modalServc.setDismissReason(JSON.stringify(jsonObj));
            this.modalRef.hide();
          }
          this.layerCreationInProgress = false;
        },
        error: (err: any) => {
          var errorTitle = err.error.title;

          console.log(err, 'error printing in POST block/level/area')

          this.errorUtil.setErrorMessage(
            err.status,
            null,
            errorTitle,
            "error",
            2000,
          );
          this.layerCreationInProgress = false;
        },
      });
    } else {
      this.siteBlockForm.markAllAsTouched();
    }
  }
}
